<div class="redirect-container">
  <div class="ui-g-11 margin-align" *ngIf="technicianRegistration?.infoBubbles.showGuestInstallerText">
    <p>{{ 'profile.phase.header' | translate }}</p>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 profile-tiles-container">
    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 option-container" *ngIf="technicianRegistration?.installerProfile">
      <div [routerLink]="['/register']" class="img-box">
        <img alt="Bild Installateur" src="assets/images/bild-installateur.png" />
      </div>
      <div class="title-container">
        <div>
          <p>{{ 'profile.phase.technician_user' | translate }}</p>
          <i
            class="pi pi-info-circle hint-icon"
            [escape]="false"
            [pTooltip]="'profile.phase.technician' | translate"
            tooltipStyleClass="netz-info-tooltip"></i>
        </div>
      </div>
    </div>

    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="technicianRegistration?.guestInstallerProfile">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 option-container">
        <div [routerLink]="['/guest']" class="img-box">
          <img alt="Bild Gast-Installateur" src="assets/images/gast-installateur.png" />
        </div>
        <div class="title-container">
          <p>{{ 'profile.phase.guest_user' | translate }}</p>
          <i
            *ngIf="technicianRegistration?.infoBubbles.showGuestInstallerButtonInfo"
            class="pi pi-info-circle hint-icon"
            [escape]="false"
            [pTooltip]="'profile.phase.guest_technician' | translate"
            tooltipStyleClass="netz-info-tooltip"></i>
        </div>
      </div>
    </div>
  </div>
</div>
